<template>
    <ul>
        <li class="level-2" v-for="(node,id) in tree" v-show="count = showNode(node)">
            <div class="checkbox checkbox-styled">
                <input :id="'facet-'+id" type="checkbox" value='"test"'>
                <label for="1">{{node.name}} <span class="result count">{{count}}</span></label>
            </div>
            <navigation-tree :showNode="showNode" :tree="node.children" v-if="node.children.length"></navigation-tree>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "NavigationTree",
        props: ['tree', 'showNode'],
        methods: {
            isNodeVisible(node) {
                return this.showNode(node);
            }
        }
    }
</script>

<style scoped>

</style>
